var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.note)+" ")]),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({staticClass:"mt-1 g-73--text text-no-wrap"},on),[_vm._v(" "+_vm._s(_vm.shortid)+" "+_vm._s(_vm.version)+" ")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.identifier))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }